import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

import './variables.css';
import './index.css';
import './chatWidget.css';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
